namespace TabAurous.OMS {
    export interface AdditionalChargesVouchersRow {
        DetailId?: number;
        AdditionalChargeId?: number;
        VoucherTypeId?: number;
        AdditionalChargeCode?: string;
        AdditionalChargeName?: string;
        ApplicableOn?: Common.AdditionalChargesType;
        RateType?: Common.AdditionalChargesRateType;
        Rate?: number;
        ProductCalculateOn?: Common.AdditionalChargesProductCalcon;
        TransactionCalculateOn?: Common.AdditionalChargesTransactionCalcon;
    }

    export namespace AdditionalChargesVouchersRow {
        export const idProperty = 'DetailId';
        export const localTextPrefix = 'OMS.AdditionalChargesVouchers';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            DetailId = "DetailId",
            AdditionalChargeId = "AdditionalChargeId",
            VoucherTypeId = "VoucherTypeId",
            AdditionalChargeCode = "AdditionalChargeCode",
            AdditionalChargeName = "AdditionalChargeName",
            ApplicableOn = "ApplicableOn",
            RateType = "RateType",
            Rate = "Rate",
            ProductCalculateOn = "ProductCalculateOn",
            TransactionCalculateOn = "TransactionCalculateOn"
        }
    }
}
